module.exports = __webpack_public_path__ + "static/media/viatris-little-island.e5d8a7dd.jpg";